import { IFilterOption } from "@logex/framework/types";
import { sortBy } from "lodash";

export function uniqueFilterCodes(arr: string[][]): string[] {
    let result: string[] = [];
    arr.forEach(x => (result = [...result, ...x]));
    return Array.from(new Set(result));
}

export function codesToMultifilterSorted(
    ids: string[],
    nameCallback: (id: string) => string | null
): IFilterOption[] {
    const filterOptions = ids
        .map(id => ({
            id,
            name: nameCallback(id)
        }))
        .filter(option => option.name != null) as IFilterOption[];

    return sortBy(filterOptions, item => item.name.toLowerCase());
}
